import { Trans } from '@lingui/macro'
import React from 'react'
import styled from 'styled-components/macro'

import useCopyClipboard from '../../../hooks/environment/useCopyClipboard'
import { LinkStyledButton } from '../../../theme'

const CopyIcon = styled(LinkStyledButton)`
  color: ${({ theme }) => theme.text1};
  flex-shrink: 0;
  display: flex;
  text-decoration: none;
  font-size: 0.825rem;
  padding-top: 5px;
  :hover,
  :active,
  :focus {
    text-decoration: none;
    color: ${({ theme }) => theme.green1};
  }
`
const TransactionStatusText = styled.span`
  margin-left: 0.25rem;
  font-size: 0.825rem;
  ${({ theme }) => theme.flexRowNoWrap};
  align-items: center;
`

export default function CopyHelper(props: { toCopy: string; children?: React.ReactNode }) {
  const [isCopied, setCopied] = useCopyClipboard()

  return (
    <CopyIcon onClick={() => setCopied(props.toCopy)}>
      {isCopied ? (
        <TransactionStatusText>
          <TransactionStatusText>
            <Trans>Copied</Trans>
          </TransactionStatusText>
        </TransactionStatusText>
      ) : (
        <TransactionStatusText />
      )}
      {isCopied ? '' : props.children}
    </CopyIcon>
  )
}
